import * as selectors from './selectors'
import * as actions from './actions'
import * as resourceSelectorActions from '../../../ResourceSelector/actions'
import { EventProps, HybridSettingsPage, ValueProps } from './HybridSettingsPage';
import { selectors as authSelectors } from '../../../../lifecycle/auth';
import { ResourceSelectorContainer } from '../../../ResourceSelector/model';
import { AppState, Dispatch } from '../../../../types';
import { connect } from 'react-redux';

const mapProps = (state: AppState): ValueProps => ({
  organizationId: authSelectors.getOrganizationId(state),
  isLoading: selectors.getIsLoading(state),
  servers: selectors.getAllServers(state),
  serversLoading: selectors.getServersLoading(state),
  selectedServerId: selectors.getSelectedServerId(state),
  selectedServerGroupId: selectors.getSelectedServerGroupId(state),
  environments: selectors.getAllEnvironments(state),
  environmentsLoading: selectors.getEnvironmentsLoading(state),
  selectedEnvironment: selectors.getSelectedEnvironment(state),
  applyingPatchSettingsAction: selectors.isConfigurationApplying(state),
  publicUrl: selectors.getAmZipUrl(state)
});

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  initializeLoading: () =>
    dispatch(actions.initializeLoading()),
  downloadedInstaller: () =>
    dispatch(actions.downloadedInstaller()),
  fetchEnvironments: (resourceSelectorContainer: ResourceSelectorContainer) =>
    dispatch(resourceSelectorActions.fetchEnvironments(resourceSelectorContainer)),
  selectEnvironment: (resourceSelectorContainer: ResourceSelectorContainer) =>
    dispatch(resourceSelectorActions.selectEnvironments(resourceSelectorContainer)),
  fetchServers: (orgId: string, envId: string) =>
    dispatch(actions.fetchServers(orgId, envId)),
  selectServer: (serverId: string) => dispatch(actions.selectServer(serverId)),
  selectServerGroup: (serverId: string) => dispatch(actions.selectServerGroup(serverId)),
  fetchPublicUrl: () => dispatch(actions.fetchAmZipUrl()),
  changeLocalStorageSettingsEnv: (environmentId: string) => dispatch(actions.changeLocalStorageSettingsEnv(environmentId))
});

export default connect(mapProps, mapDispatch)(HybridSettingsPage)
